<p-card data-testid="project-language-card">
  <app-card-title key="project.steps.projectLanguage" />
  <div class="space-y-5">
    <div class="w-80">
      <app-model-field-select
        id="project-language-select"
        testId="project-language-select"
        label="common.language"
        tooltipKey="projectSetting_projectLanguage"
        optionLabel="label"
        optionValue="isoCode"
        [options]="languageOptions()"
        [filter]="true"
        [isRequired]="true"
        [disabled]="disabled()"
        [(value)]="selectedLanguage"
      />
    </div>

    @if (shouldShowSaveButton()) {
      <div class="flex justify-end">
        <app-project-step-save-button
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        ></app-project-step-save-button>
      </div>
    }
  </div>
</p-card>
